module.exports = __webpack_public_path__ + "img/zmt.ff98bdc1.png";